import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/i18n/language-context';
import { ErrorBoundary } from './ui/error-boundary';
import { Title } from './ui/layout';
import { Link } from './ui/link';
import { SiteShell } from './site-shell';

export function ApplicationBoundary({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  const { t } = useLanguage();
  const safeQuery = new URLSearchParams(location.search);
  safeQuery.delete('start');
  const href = `${location.pathname}${safeQuery.size ? `?${safeQuery}` : ''}`;
  return (
    <ErrorBoundary
      resetKey={location.pathname}
      fallback={
        <SiteShell>
          <main id="main-content" className="center-page" tabIndex={-1}>
            <div className="info-panel ui-stack" role="alert">
              <Title>{t.unexpectedError}</Title>
              <p>{t.recoveryNotice}</p>
              <Link href={href} appearance="primary">
                {t.reloadPage}
              </Link>
              <Link to="/">{t.home}</Link>
            </div>
          </main>
        </SiteShell>
      }
    >
      {children}
    </ErrorBoundary>
  );
}
